import { HiddenPropertyNames } from 'forms-utils-lib/constants/Properties';
const isPropertyNameHidden = propertyName => {
  const hasHsPrefix = propertyName.indexOf('hs_') === 0;
  const onBlockList = HiddenPropertyNames.findIndex(i => propertyName === i) >= 0;
  return hasHsPrefix || onBlockList;
};
export default isPropertyNameHidden;